import * as React from 'react';
import {Modal, ModalProps} from "semantic-ui-react";
import {toast} from "react-toastify";

interface TracModalProps extends ModalProps {
    header: any;
    content: () => any;
    actions: () => any;
}

interface TracModalState {
}

class TracModal extends React.Component<TracModalProps, TracModalState> {

    constructor(props: TracModalProps, state: TracModalState) {
        super(props,state);
        this.state = {
        };
    }

    componentDidMount(): void {

    }

    public render() {
     return (
            <Modal {...this.props}>
                <Modal.Header>
                    {this.props.header}
                </Modal.Header>
                <Modal.Content>
                    {this.props.content()}
                </Modal.Content>
                <Modal.Actions>
                    {this.props.actions()}
                </Modal.Actions>
            </Modal>
        );
    }
}

export default TracModal;